import React, { useRef, useState, useEffect } from 'react'
import {MdShoppingBasket} from 'react-icons/md'
import {motion} from 'framer-motion'
import NotFound from '../image/NotFound.svg'
import { useStateValue } from '../context/StateProvider'
import { actionType } from '../context/reducer'

const RowContainer = ({flag, data, scrollValue}) => {
    const RowContainer = useRef();

    const [items, setItems] = useState([]);

    const[{cartItems}, dispatch] = useStateValue();

    const addtocart = () =>{
        dispatch({
            type: actionType.SET_CARTITEMS,
            cartItems: items,
        });
        localStorage.setItem("cartItems", JSON.stringify(items));
    };

    useEffect(() => {
        RowContainer.current.scrollLeft += scrollValue;
    }, [scrollValue]);

    useEffect(() => {
        addtocart()
    }, [items]);

  return (
    <div
    ref={RowContainer}
     className={`w-full my-12 scroll-smooth flex items-center gap-3 bg-orange-50 ${flag ? 'overflow-x-scroll scrollbar-none' : 'overflow-x-hidden flex-wrap justify-center'}`}>
    
    {data && data.length > 0 ?
     data.map((item) =>(
        <div key={item.id} className='w-300 min-w-[300px] md:w-340 md:min-w-[340px] md:w-250 h-[230px] my-12 bg-cardOverlay rounded-lg p-2 backdrop-blur-lg hover:drop-shadow-xl flex flex-col items-center justify-between'> 
            <div className='w-full flex items-center justify-between'>
                <motion.div className='w-40 h-40 -mt-8 drop-shadow-2xl' whileHover={{scale: 1.2}}>
                <img 
                
                src={item?.imageURL} alt='image'
                    className='w-full h-full object-contain'
                />
                </motion.div>
                
                <motion.div 
                whileTap={{scale:0.75}}
                className='w-8 h-8 rounded-full flex items-center justify-center cursor-pointer bg-red-600 hover:shadow-md'
                onClick={() => setItems([...cartItems, item])}> 
                    <MdShoppingBasket className='text-white'/>
                </motion.div>
            </div>
            <div className='w-full flex flex-col items-end justify-end'>
                <p className='text-textColor font-semibold text-base md:text-lg'>{item?.title}</p>
                <p className='mt-1 text-sm text-gray-500'>{item?.calories} Calories</p>
                <div className='flex items-center gap-8'>
                    <p className='text-lg text-headingColor font-semibold '><span className='text-sm text-red-500'>$</span>{item?.price}</p>
                </div>
            </div>
        </div>
    )): (
        <div className='w-full flex flex-col items-center justify-center'>
            <img src={NotFound} className='h-340'/>
            <p className='text-xl text-headingColor font-semibold my-2'>Item not available.</p>
        </div>
        )}
    </div>
  )
}

export default RowContainer